class QuizOptionHeightService {
  static resolvedValue(element, variant, field) {
    return (
      field?.options?.["quiz-option-height"] ||
      element?.options?.["quiz-option-height"] ||
      variant?.options?.["quiz-option-height"] ||
      "small"
    );
  }

  static equalize(question, element, variant, field) {
    const options = question.querySelectorAll(".cf-quiz-question-option");
    options.forEach((option) => {
      option.style.minHeight = "";
    });

    if (
      QuizOptionHeightService.resolvedValue(element, variant, field) !== "auto"
    ) {
      return;
    }

    let tallest = 0;
    options.forEach((option) => {
      tallest = Math.max(tallest, option.offsetHeight);
    });

    if (tallest > 0) {
      options.forEach((option) => {
        option.style.minHeight = `${tallest}px`;
      });
    }
  }

  static apply(question, element, variant, field) {
    const remeasure = () =>
      QuizOptionHeightService.equalize(question, element, variant, field);

    remeasure();

    if (
      QuizOptionHeightService.resolvedValue(element, variant, field) !== "auto"
    ) {
      return;
    }

    requestAnimationFrame(remeasure);

    if (
      typeof document.fonts !== "undefined" &&
      document.fonts.status !== "loaded" &&
      !question.dataset.cfHeightFonts
    ) {
      question.dataset.cfHeightFonts = "1";
      document.fonts.ready.then(() => {
        delete question.dataset.cfHeightFonts;
        remeasure();
      });
    }

    question
      .querySelectorAll(".cf-quiz-question-option img")
      .forEach((image) => {
        if (image.complete || image.dataset.cfHeightBound) return;

        image.dataset.cfHeightBound = "1";
        const settled = () => {
          delete image.dataset.cfHeightBound;
          remeasure();
        };
        image.addEventListener("load", settled, { once: true });
        image.addEventListener("error", settled, { once: true });
      });
  }
}

export default QuizOptionHeightService;
